module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/chiba_funabashi_point4_2-d7819aaebbe894c769a2a7392beccd05.jpg";